import { CardStatementOperationData } from "./cardStatementOperationData";
import { DateType } from "./types/index";

/**
 * Класс данных выписки карты.
 */
export class CardStatementData {
  /**
   * Список операции в выписке карты.
   */
  public Operations: Array<CardStatementOperationData> = [];

  /**
   * ИД карты.
   */
  public CardId: number = 0;

  /**
   * ИД счёта.
   */
  public ContractId: number = 0;

  /**
   * Сумма прихода средств.
   */
  public CreditSum: number = 0;

  /**
   * Сумма расходов средств.
   */
  public DebitSum: number = 0;

  /**
   * Дата начала выписки операций карты.
   */
  public DateBegin: DateType = null;

  /**
   * Дата окончания выписки операций карты.
   */
  public DateEnd: DateType = null;

  /**
   * Референс карты.
   */
  public Reference: string = "";

  /**
   * Валюта карты.
   */
  public CurrencyCharCode: string = "";

  /**
   * Остаток средств на карте на начало выписки.
   */
  public RestIn: number = 0;

  /**
   * Остаток средств на карте на конец выписки.
   */
  public RestOut: number = 0;

  /**
   * Общее количество операций в выписке карты.
   */
  public Size: number = 0;

  /**
   * Количество пропущенных операций не занесённых в выписку карты.
   * начиная с '0' элемента.
   */
  public Skip: number = 0;

  /**
   * Тип сортировки.
   */
  public SortType: number = 0;

  /**
   * Желаемое количество выборки операций карты.
   */
  public Take: number = 0;

  /**
   * Валюта
   */
  public Currency: string = "";

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      const jsi = src.SystemInfo.Data.Properties;
      this.Currency = src.Data.Properties.currencyCharCode ?? "";
      this.CardId = jsi.cardId ?? 0;
      this.CreditSum = jsi.creditSum ?? 0;
      this.DebitSum = jsi.debitSum ?? 0;
      this.Reference = jsi.reference ?? "";
      this.RestIn = jsi.restIn ?? 0;
      this.RestOut = jsi.restOut ?? 0;
      this.Size = jsi.size ?? 0;

      const jd = src.Data.InnerData.Data;

      for (const i in jd) {
        this.Operations.push(new CardStatementOperationData(jd[i].Properties));
      }

      const ccc = src.Data.Properties;
      this.CurrencyCharCode = ccc.currencyCharCode ?? "";
    }
  }
}
